// Cookie name
export const NFL_BANNER_FLAG = 'dsp_nfl_game_pass';
